import React from 'react'
import PageBody from '../../../components/pagebody/PageBody'
import Heading from '../../../components/heading/Heading'
import { HEADING } from '../../../components/heading/constants/constants'
import ApiInformation from '../component/apiinformation/ApiInformation'
import EnableApiAccess from '../component/enableapiaccess/EnableApiAccess'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey } from '../ApiSlice'
import Button from '../../../components/button/Button'
import styles from './ApiHub.styles'
import Loadable from '../../../components/loadable/Loadable'
import { API_HUB_LOADING_STATES, API_HUB_LOADING_STATES_MESSAGE_MAP } from '../../constants/constants'
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook'

function ApiHub() {
	const { isMndaSigned, loadingState, isActive } = useSelector((state) => state[componentKey])
	const navigate = useTxNavigate();

	return (
		<Loadable currentState={loadingState.state} loadingStates={API_HUB_LOADING_STATES.DETAIL_LOADING} messageMap={API_HUB_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
			<PageBody>
				<div style={styles.titleRow}>
					<Heading type={HEADING.H1}>API Hub</Heading>
					{ (isMndaSigned && isActive) && <Button onClickCb={() => navigate(`/api/developerhub`)}>Manage Developers</Button>}
				</div>
				{(isMndaSigned && isActive) ? <ApiInformation /> : <EnableApiAccess />}
			</PageBody>
		</Loadable>
	)
}

export default ApiHub